/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcDtccUtcV1UtcFixSessionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_DTCC_UTC_V1_UTC_FIX_SESSION_STATE_ENTITY_NAME = 'exc.dtcc.utc.v1.UtcFixSession';
export const excDtccUtcV1UtcFixSessionStateEntity = new schema.Entity<ExcDtccUtcV1UtcFixSessionState>(EXC_DTCC_UTC_V1_UTC_FIX_SESSION_STATE_ENTITY_NAME, {}, { idAttribute: 'sessionId' });

